import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import memoize from 'lodash/memoize';
import moment from 'moment';
import { Breadcrumb, Form } from 'antd';
import { Link } from 'react-router-dom';

import CallbackModal from '../../../../components/CallbackModal';
import TncForm from '../../components/TncForm/TncForm.form.component';
import allBillersRoute from '../../route';

import text from './TncUpdate.page.translation';

const FormTncUpdate = Form.create()(TncForm);

class TncUpdate extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalCallbackVisible: false,
      isCreateSuccess: false,
    };
  }

  componentDidMount() {
    const { defaultData, match } = this.props;
    if (match.params.id && defaultData.public_id !== match.params.id)
      this.props.getTncDetail(match.params.id);
  }

  renderBreadCrumb = () => (
    <div className="breadcrumb-wrapper">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={allBillersRoute.TNC_LIST}>
            {this.props.intl.formatMessage(text.list)}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          {this.props.intl.formatMessage(text.update)}
        </Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );

  creteInitData = memoize(data => {
    const prevVersionNumber = parseInt(
      data.latest_version.name.split('_')[0].substring(1),
      10,
    );
    const newVersion = `V${prevVersionNumber + 1}_${moment().format(
      'DDMMYYYY',
    )}`;

    return {
      ...data,
      fileVersion: newVersion,
      prevVersion: data.latest_version.name,
    };
  });

  onSubmit = value => {
    this.props.updateTnC(
      this.props.defaultData.public_id,
      value,
      this.onCallbackSubmit,
    );
  };

  onCallbackSubmit = status => {
    this.setState({
      modalCallbackVisible: true,
      isCreateSuccess: status === 'success',
    });
  };

  redirectDetail = publicID => () => {
    const redirect = allBillersRoute.TNC_DETAIL.replace(':id', publicID);
    this.props.history.replace(redirect);
  };

  onCloseModal = () => {
    const { defaultData } = this.props;
    this.setState(
      {
        modalCallbackVisible: false,
      },
      this.redirectDetail(defaultData.public_id),
    );
  };

  render() {
    const { defaultData, match, loading } = this.props;
    const renderWhenReady = !match.params.id || defaultData.public_id;
    return (
      <div className="main-content tnc-list">
        {this.renderBreadCrumb()}

        <div className="white-box-wrapper">
          {renderWhenReady && (
            <FormTncUpdate
              isEdit
              currentValue={this.creteInitData(this.props.defaultData)}
              intl={this.props.intl}
              onSubmit={this.onSubmit}
              loading={loading}
            />
          )}
        </div>
        <CallbackModal
          modalVisible={this.state.modalCallbackVisible}
          type={this.state.isCreateSuccess ? 'success' : 'error'}
          onClose={this.onCloseModal}
          btnText="Close"
          description={`Update Terms & Conditions ${
            this.state.isCreateSuccess ? 'Success' : 'Failed'
          }`}
        />
      </div>
    );
  }
}

TncUpdate.propTypes = {
  intl: PropTypes.object.isRequired,
  defaultData: PropTypes.object.isRequired,
  match: PropTypes.object,
  getTncDetail: PropTypes.func,
  loading: PropTypes.bool,
  updateTnC: PropTypes.func,
  history: PropTypes.object,
};

export default TncUpdate;
